export default __webpack_public_path__ + "static/media/logo.fb148a0e.png";